import {Cache} from "./Cache";

class LoginTeam extends Cache {
    constructor() {
        super();
        this.key += '_login_team';
    }
}

export const loginTeamCache = new LoginTeam();
